<template>
  <article class="d-flex flex-column pt-9 px-5" v-if="category">
    <page-grid-internal :category="category" />
  </article>
</template>

<script>
import clickHandler from "~/mixins/clickHandler";
import categoryService from "@/commons/service/categoryService";
export default {
  name: "LeafletInformationModalEBSN",
  mixins: [clickHandler],
  data() {
    return {
      category: null
    };
  },
  methods: {
    onLinkClick(e) {
      this.$emit(true);
      this.$nextTick(() => {
        this.clicked(e);
      });
    }
  },
  async mounted() {
    this.category = await categoryService.getCategoryBySlug("leaflet-info");
  }
};
</script>
